enum WeatherReports {
  SUNNY = "4",
  PARTLY_CLOUDY = "3",
  CLOUDY = "2",
  RAINY = "1",
  STORMY = "0",
}

export { WeatherReports };
